import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next';

export const mutateAdAssign = (initParams) => {
    // Status messages in the user's language, not the server's English text.
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationKey: ['ad-assign', initParams],
        mutationFn: async (formData = {}) => {
            const res = await axios.put(route('studio.v1.api.ads.assign'), { ...initParams, ...formData });
            return res;
        },
        onSuccess: async ({ data }) => {

            notifications.show({
                color: 'green',
                title: t('ads.toast.assigned'),
            })

        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: t('common.error'),
                message: response?.data?.message || "",
            })
        }
    });

    return mutation;
}
